export enum ConfigNodeMenuId {
  SIDENAV = "SIDENAV",
  CENTRAL = "CENTRAL"
}
